import { render, staticRenderFns } from "./login.vue?vue&type=template&id=2f656882&scoped=true&lang=pug&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./footer.scss?vue&type=style&index=0&id=2f656882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f656882",
  null
  
)

export default component.exports